(function () {
  'use strict';

  angular.module('app').component('billPage', BillPageComponent());

  function BillPageComponent() {
    return {
      bindings: {},
      controller: BillDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bills/bill-page.component.html',
    };
  }

  BillDetailCtrl.$inject = ['$location', '$routeParams', 'AbilityService', 'BillService'];

  function BillDetailCtrl($location, $routeParams, AbilityService, BillService) {
    const vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_bill_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    // Methods
    vm.onBillSaved = onBillSaved;
    vm.onBillCanceled = onBillCanceled;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        //edit
        vm.loadingItem = true;
        BillService.getBill(itemId).then(function (data) {
          vm.bill = data;

          vm.loadingItem = false;
        });
      } else {
        vm.bill = {};
      }
    }

    function onBillSaved(item) {
      $location.path(`/bills/${item.id}`);
    }

    function onBillCanceled() {
      $location.path('/bills');
    }
  }
})();
